import React from 'react';
import { Grid, Link } from '@mui/material';
import GadgetLoader from '../../Loaders/GadgetLoader';
import EnhancedDataGrid from '../../Common/EnhancedDataGrid';
import CircularProgress from '@mui/material/CircularProgress';
import { getFileIcon } from '../../Common/Utilities';
import Tooltip from '@mui/material/Tooltip';


const TopLeftGadget = ({
    xsVal,
    gridCss,
    keyVal,
    thisRef,
    fontSize,
    fontStyle,
    cellStyle,
    headerStyle,
    hasSearchedOnce
}) => {
    const { dragging } = thisRef.state;

    const queuedInvoiceRows = React.useMemo(() => {
        const rows = thisRef.state.queuedInvoices || [];

        return rows.map(row => {
            const scanDate = row?.scanDate;
            const minutes = scanDate
                ? Math.abs(new Date() - new Date(scanDate)) / 60000
                : 0;

            return {
                ...row,
                uploadStatus: (scanDate && row.uploadStatus === 2 && minutes > 12 * 60)
                    ? 1
                    : row.uploadStatus
            };
        });
    }, [thisRef.state.queuedInvoices]);

    const tableOptionsTopLeft = {
        minBodyHeight: 230,
        maxBodyHeight: 230,
        headerStyle: { fontSize: fontSize },
        searchFieldStyle: fontStyle,
        actionsColumnIndex: -1,
        selection: true,
        showTextRowsSelected: false,
        selectionProps: (rowData) => {
            const checked = rowData.uploadStatus === 2 ? { checked: false } : {};
            //const checked = rowData.invoiceDocumentScanStatusId === 30 ? { checked: false } : {};
            return {
                color: 'default',
                disabled: rowData.uploadStatus === 2,
                //disabled: rowData.invoiceDocumentScanStatusId === 30,
                ...checked
            }
        }
    };

    const hasLongFileName = React.useMemo(() => {
        const rows = queuedInvoiceRows || [];

        return rows.some(r => {
            const name = (r?.fileName || '').trim();

            if (!name) return false;

            if (name.length > 35) return true;

            if (name.length > 22 && !name.includes(' ')) return true;

            return false;
        });
    }, [queuedInvoiceRows]);

    //const hasLongFileName = React.useMemo(() => {
    //    const rows = thisRef.state.queuedInvoices || [];

    //    return rows.some(r => {
    //        const name = (r?.fileName || '').trim();

    //        if (!name) return false;

    //        if (name.length > 35) return true;

    //        if (name.length > 22 && !name.includes(' ')) return true;

    //        return false;
    //    });
    //}, [thisRef.state.queuedInvoices]);

    const isWeeksToFilterSearchActive = React.useMemo(() => {
        const text = thisRef.state.filterText[1];
        const prev = thisRef.state.prevSearchText[1];
        const weeks = thisRef.state.weeksToFilter1;
        return (
            (text !== '' && weeks !== 0) ||
            (weeks === 0 && text === prev && text.trim() !== '')
        );
    }, [thisRef.state.filterText[1], thisRef.state.prevSearchText[1], thisRef.state.weeksToFilter1]);
    const serverProps = React.useMemo(() => { return thisRef.state.serverMode[1] && thisRef.state.weeksToFilter1 === 0 ? { filterMode: "server" } : {} }, [thisRef.state.serverMode[1], thisRef.state.weeksToFilter1])
    const toolTipMessage = React.useMemo(() => { return (thisRef.state.serverMode[1] && thisRef.state.weeksToFilter1 === 0) ? thisRef.toolTipMessage : '' }, [thisRef.state.weeksToFilter1, thisRef.state.serverMode[1]]);
    return <Grid item xs={xsVal} className="fade-in" key={keyVal}>
        <div className="drag_area"
            style={{ ...gridCss, position: 'relative' }}
            onDragOver={thisRef.handleDragOver}
            onDragLeave={thisRef.handleDragLeave}
            onDrop={thisRef.handleDrop}
        >
            {dragging && (
                <div className={`upload-file-zone ${dragging ? 'dragging' : ''}`}>
                    <label htmlFor="file-input">
                        <div className="drop-file-wrapper">
                            <span className="file-info-msg">Drop Invoice Document(s) Here to Upload </span>
                        </div>
                    </label>
                </div>
            )}

            <GadgetLoader loading={thisRef.state.gadgetLoading[1]} />
            <EnhancedDataGrid
                //rows={thisRef.state.queuedInvoices}
                rows={queuedInvoiceRows}
                disableColumnMenu
                pagination
                title="Invoice Queue (waiting to be scanned)"
                gridRef={thisRef.invoiceQueueGridRef}
                pageSize={thisRef.state.pageSize}
                toolTipMessage={toolTipMessage}
                hasSearchedOnce={hasSearchedOnce}
                {...serverProps}
                onSearchFocus={() => thisRef.handleSearchFocus(1)}
                searchCallback={
                    null
                    //(searchText) => {
                    //const trimmedText = (searchText || "").trim();
                    //const prevText = thisRef.state.prevSearchText[1];


                    //if (trimmedText === "" && prevText !== "") {
                    //    thisRef.setState((prevState) => ({
                    //        prevSearchText: {
                    //            ...prevState.prevSearchText,
                    //            1: ""
                    //        }
                    //    }), () => {
                    //        thisRef.fetchDashboard(1, thisRef.state.weeksToFilter1 ?? 0, searchText);
                    //    });
                    //    return;
                    //}


                    //if (trimmedText !== "" && trimmedText !== prevText) {
                    //    thisRef.setState((prevState) => ({
                    //        prevSearchText: {
                    //            ...prevState.prevSearchText,
                    //            1: trimmedText
                    //        }
                    //    }), () => {
                    //        thisRef.fetchDashboard(1, thisRef.state.weeksToFilter1 ?? 0, searchText);
                    //    });
                    //}
                    //}
                }


                rowsPerPageOptions={thisRef.state.rowsPerPage}

                //showSearchTooltip={
                //    thisRef.state.switchToFullScreen &&
                //    thisRef.state.showGadget === 1 &&
                //    thisRef.state.showSearchTooltip 
                //}
                showSearchTooltip={false}
                footerMessage={''}
                setFilterText={(text) => { thisRef.setFilterText(1, text) }}
                filterText={thisRef.state.filterText[1]}
                isWeeksToFilterSearchActive={isWeeksToFilterSearchActive}
                sortModel={thisRef.state.sortModel[1]}
                onSortModelChange={(model) => thisRef.setSortModel(1, model)}
                isRowSelectable={(params) => params.row.uploadStatus !== 2}
                //isRowSelectable={(params) => params.row.invoiceDocumentScanStatusId !== 30}
                initialState={{
                    sorting: {
                        sortModel: (() => {
                            const persisted = thisRef.state.sortModel?.[2] || [];
                            const hasField = persisted.some(s => s.field === 'documentManualUploadFileUpdateDate');
                            return hasField
                                ? persisted
                                : [{ field: 'documentManualUploadFileUpdateDate', sort: 'desc' }, ...persisted];
                        })()
                    }
                }}
                columns={[
                    //{
                    //    headerName: 'File Name',
                    //    field: 'fileName',
                    //    flex: 1,
                    //    cellStyle: cellStyle,
                    //    headerStyle: headerStyle,
                    //    renderCell: (rowData) => {
                    //        const { documentManualUploadRecordId, invoiceDocumentFileLocation, fileName } = rowData.row;
                    //        const isDownloading = thisRef.state.downloadingInvoices[documentManualUploadRecordId];

                    //        if (isDownloading) {
                    //            return (
                    //                <div
                    //                    style={{
                    //                        display: 'flex',
                    //                        justifyContent: 'center',
                    //                        alignItems: 'center',
                    //                        width: '100%',
                    //                        height: '100%',
                    //                    }}
                    //                >
                    //                    <CircularProgress size={18} />
                    //                </div>
                    //            );

                    //        }

                    //        if (!invoiceDocumentFileLocation) {
                    //            return fileName || '';
                    //        }

                    //        return (
                    //            <Link
                    //                href="#"
                    //                onClick={(e) => {
                    //                    e.preventDefault();
                    //                    e.stopPropagation();
                    //                    thisRef.downloadFile(1, documentManualUploadRecordId, invoiceDocumentFileLocation);
                    //                }}
                    //            >
                    //                {fileName}
                    //            </Link>
                    //        );
                    //    }
                    //},
                    {
                        headerName: 'File Name',
                        field: 'fileName',
                        ...(thisRef.state.isExpanded
                            ? {
                                flex: hasLongFileName ? 2 : 1,
                                minWidth: hasLongFileName ? 300 : 220
                            }
                            : {
                                flex: hasLongFileName ? 2 : 1,
                                minWidth: hasLongFileName ? 260 : 160
                            }
                        ),
                        cellStyle: cellStyle,
                        headerStyle: headerStyle,
                        renderCell: (rowData) => {
                        const {
                            documentManualUploadRecordId,
                            invoiceDocumentFileLocation,
                            fileName
                        } = rowData.row;

                        const isDownloading =
                            thisRef.state.downloadingInvoices[documentManualUploadRecordId];

                        const text = fileName || '';
                        const hasWhitespace = /\s/.test(text);

                        const textStyle = hasWhitespace
                            ? {
                                flex: 1,
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                wordBreak: 'normal',         // break on spaces only
                                overflowWrap: 'break-word',  // keep reasonable wrapping
                                whiteSpace: 'normal',
                                lineHeight: 1.3,
                            }
                            : {
                                flex: 1,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',        // long single token -> ellipsis
                                display: 'block',
                                lineHeight: 1.3,
                            };

                        if (isDownloading) {
                            return (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        height: '100%',
                                    }}
                                >
                                    <CircularProgress size={18} />
                                </div>
                            );
                        }

                        if (!invoiceDocumentFileLocation) {
                            return (
                                <Tooltip title={text} placement="top-start">
                                    <span style={textStyle}>{text}</span>
                                </Tooltip>
                            );
                        }

                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0, // 👈 tighter spacing between icon and name
                                    width: '100%',
                                    overflow: 'hidden',
                                }}
                            >
                                <Tooltip title="View">
                                    <span
                                        role="button"
                                        tabIndex={0}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            flexShrink: 0,
                                        }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            thisRef.downloadFile(
                                                documentManualUploadRecordId,
                                                invoiceDocumentFileLocation
                                            );
                                        }}
                                    >
                                        {getFileIcon(invoiceDocumentFileLocation)}
                                    </span>
                                </Tooltip>

                                <Tooltip title={text} placement="top-start">
                                    <span style={textStyle}>{text}</span>
                                </Tooltip>
                            </div>
                        );
                        }
                    },


                    {
                        headerName: 'Received Date',
                        field: 'documentManualUploadFileUpdateDate',
                        //type: 'datetime',
                        type: 'date',
                        //defaultSort: 'desc',
                        valueGetter: ({ value }) => value || '',
                        valueFormatter: ({ value }) => {
                            if (!value) return '';
                            const d = new Date(value);
                            return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC' }).format(d);
                        },
                        cellStyle: cellStyle,
                        headerStyle: headerStyle,
                        ...(hasLongFileName
                            ? { width: 120, flex: 0 }
                            : { flex: 2, minWidth: 120 }
                        )
                    },
                    {
                        headerName: 'Status',
                        field: 'uploadStatus',
                        cellStyle: cellStyle,
                        headerStyle: headerStyle,
                        ...(hasLongFileName
                            ? { width: 120, flex: 0 }
                            : { flex: 2, minWidth: 120 }
                        ),
                        //renderCell: rowData => this.displayUploadStatus(rowData.value)
                        renderCell: rowData => {
                            //var scanDate = rowData.row.scanDate;
                            //var Minutes = Math.abs(new Date() - new Date(scanDate)) / 60000;
                            //if (scanDate && rowData.row.uploadStatus === 2 && Minutes > 12 * 60) {
                            //    rowData.row.uploadStatus = 1
                            //}
                            return (thisRef.displayUploadStatus(rowData.row.uploadStatus));
                        }
                    },
                    //{
                    //    headerName: 'View',
                    //    field: 'view',
                    //    cellStyle: cellStyle,
                    //    headerStyle: headerStyle, resizable: false, sortable: false,
                    //    width: 150,
                    //    renderCell: rowData => (
                    //        <Link data-rowid={rowData.row.rowId} data-gadgetname="queuedInvoices" href="#" onClick={thisRef.viewLink_clickHandler}>View</Link>
                    //    )
                    //},
                    {
                        headerName: 'Scan Now',
                        field: 'scanNow',
                        cellStyle: cellStyle,
                        headerStyle: headerStyle,
                        ...(hasLongFileName
                            ? { width: 100, flex: 0 }
                            : { flex: 1, minWidth: 100 }
                        ),
                        renderCell: rowData => {
                            var scanDate = rowData.row.scanDate;
                            var Minutes = Math.abs(new Date() - new Date(scanDate)) / 60000;
                            return (<div>
                                {rowData.row.uploadStatus === 1 && <Link data-documentmanualuploadrecordid={rowData.row.documentManualUploadRecordId} data-gadgetnumber={1} href="#" onClick={thisRef.scan_clickHandler}>Scan</Link>}
                                {(scanDate && rowData.row.uploadStatus === 2 && Minutes > 12 * 60) && <Link data-rowid={rowData.row.documentManualUploadRecordId} data-mode="Rescan" href="#" onClick={thisRef.invoiceDocumentRescan_clickHandler}>Scan</Link>}
                            </div>)
                        }
                    },
                    //{
                    //	headerName: 'Scan with AI',
                    //	field: 'scanNow',
                    //	cellStyle: cellStyle,
                    //	headerStyle: headerStyle,
                    //	width: 150,
                    //	renderCell: rowData => (
                    //		rowData.row.uploadStatus === 1 ? <Link data-documentmanualuploadrecordid={rowData.row.documentManualUploadRecordId} href="#" onClick={thisRef.scan_clickAIHandler}>Scan</Link> : null
                    //	)
                    //}
                ]}
                customcomponent={<>
                    {thisRef.getOpenInFullScreenButton(1)}
                    {thisRef.getRefreshButton(1)}
                    {thisRef.getSearchButton(1)}
                    <input
                        type="file"
                        multiple
                        accept="application/pdf,image/jpg,image/jpeg,image/png"
                        id="contained-button-file"
                        style={{ display: "none" }}
                        onChange={thisRef.fileUpload_changeHandler} />
                    {thisRef.getDeleteButton(1)}
                    {thisRef.getScanButton(1)}
                    {thisRef.getUploadButton(1)}
                    {thisRef.getWeeksToFilterDropDown(1, thisRef.state.filterText[1] || '')}
                </>
                }
                options={tableOptionsTopLeft}
                onSelectionChange={(rows) => {
                    thisRef.scanSelectedRows = rows

                }}
                quickFilterDebounceMs={thisRef.getQuickFilterDebounceMs(1)}
                getRowId={(row) => row.rowId}
                disableRowSelectionOnClick
            />

        </div>
    </Grid>

};

export default TopLeftGadget;
